// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity-selector {
  display: flex;
  font-size: calc(var(--quantity-selector-height) / 2);
  background: var(--ion-color-primary);
  border-radius: 60px;
}
.quantity-selector > * {
  line-height: var(--quantity-selector-height);
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: var(--quantity-selector-height);
  height: var(--quantity-selector-height);
  cursor: pointer;
  background-color: var(--color-white);
  border: 1px solid var(--ion-color-tertiary);
  font-family: AppFontSemiBold;
  font-size: var(--quantity-font-size);
  line-height: 28.8px;
  text-align: center;
  color: var(--ion-color-tertiary);
}
.circle.minus {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.circle.plus {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.rectangle {
  background: var(--color-white) !important;
  color: var(--ion-color-tertiary);
  width: calc(1 * var(--quantity-selector-height));
  height: var(--quantity-selector-height);
  border-top: 1px solid var(--ion-color-tertiary);
  border-bottom: 1px solid var(--ion-color-tertiary);
  font-family: AppFontSemiBold;
  font-size: var(--quantity-font-size);
  line-height: 28.8px;
  text-align: center;
}

.cart-screen > * {
  background: var(--color-white);
}`, "",{"version":3,"sources":["webpack://./src/app/components/quantity-selector/quantity-selector.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,oDAAA;EACG,oCAAA;EACA,mBAAA;AACJ;AACC;EAEC,4CAAA;EACA,UAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAaA;EACE,sCAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,2CAAA;EACA,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AAVF;AAaE;EACE,2BAAA;EACA,8BAAA;AAXJ;AAcE;EACE,4BAAA;EACA,+BAAA;AAZJ;;AAgBA;EACC,yCAAA;EACA,gCAAA;EACA,gDAAA;EACA,uCAAA;EACG,+CAAA;EACA,kDAAA;EACH,4BAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AAbD;;AAiBC;EACC,8BAAA;AAdF","sourcesContent":[".quantity-selector {\n\tdisplay: flex;\n\tfont-size: calc(var(--quantity-selector-height) / 2);\n    background: var(--ion-color-primary);\n    border-radius: 60px;\n\n\t> * {\n\t\t// background: #c6aa7a;\n\t\tline-height: var(--quantity-selector-height);\n\t\tpadding: 0;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t// &:first-child {\n\t\t// \tborder-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\t// }\n\n\t\t// &:last-child {\n\t\t// \tborder-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\t// }\n\t}\n}\n\n.circle {\n  width: var(--quantity-selector-height);\n  height: var(--quantity-selector-height);\n  cursor: pointer;\n  background-color: var(--color-white);\n  border: 1px solid var(--ion-color-tertiary);\n  font-family: AppFontSemiBold;\n  font-size: var(--quantity-font-size);\n  line-height: 28.8px;\n  text-align: center;\n  color: var(--ion-color-tertiary);\n\n\n  &.minus {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  &.plus {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n}\n\n.rectangle {\n\tbackground: var(--color-white) !important;\n\tcolor: var(--ion-color-tertiary);\n\twidth: calc(1 * var(--quantity-selector-height));\n\theight: var(--quantity-selector-height);\n    border-top: 1px solid var(--ion-color-tertiary);\n    border-bottom: 1px solid var(--ion-color-tertiary);\n\tfont-family: AppFontSemiBold;\n\tfont-size: var(--quantity-font-size);\n\tline-height: 28.8px;\n\ttext-align: center;\n}\n\n.cart-screen {\n\t> * {\n\t\tbackground: var(--color-white);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
